"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default, exports.CAPTION_SAMPLES = exports.LANGUAGES = void 0;

var _react = _interopRequireDefault(require("react")),
    _utils = require("../utils"),
    LANGUAGES = {
  EN: "English (US)",
  JA: "Japanese",
  AR: "Arabic",
  ZH: "Chinese",
  CS: "Czech",
  NL: "Dutch",
  FR: "French",
  DE: "German",
  IT: "Italian",
  KO: "Korean",
  PL: "Polish",
  PT: "Portuguese",
  RU: "Russian",
  ES: "Spanish",
  TR: "Turkish"
};

exports.LANGUAGES = LANGUAGES;
var PREFIX_OVERRIDES = {
  EN: "us"
},
    CAPTION_SAMPLES = {
  EN: "An example subtitle",
  JA: "\u5B57\u5E55\u306E\u4F8B",
  AR: "\u0645\u062B\u0627\u0644 \u0627\u0644\u062A\u0631\u062C\u0645\u0629",
  ZH: "\u4E00\u4E2A\u793A\u4F8B\u5B57\u5E55",
  CS: "P\u0159\xEDklad titulk\u016F",
  NL: "Een voorbeeld ondertitel",
  FR: "Un exemple de sous-titre",
  DE: "Ein Beispiel f\xFCr einen Untertitel",
  IT: "Un sottotitolo di esempio",
  KO: "\uC790\uB9C9 \uC608",
  PL: "Przyk\u0142adowy podtytu\u0142",
  PT: "Um exemplo de legenda",
  RU: "\u041F\u0440\u0438\u043C\u0435\u0440 \u0441\u0443\u0431\u0442\u0438\u0442\u0440\u0430",
  ES: "Un subt\xEDtulo de ejemplo",
  TR: "\xD6rnek bir altyaz\u0131"
};
exports.CAPTION_SAMPLES = CAPTION_SAMPLES;

function _default() {
  return function (a) {
    var b = a.billingEntityCode,
        c = a.addonsCosts,
        d = a.includedAddons;
    return function (a) {
      var e = (0, _utils.getCostForAddon)({
        billingEntityCode: b,
        costs: null
      }),
          f = Object.keys(LANGUAGES).map(function (f) {
        var g = (0, _utils.isFreeAddon)({
          addonKey: a,
          addonValue: f,
          includedAddons: d
        }) ? e : (0, _utils.getCostForAddon)({
          costs: c[a].costs,
          billingEntityCode: b
        });
        return {
          label: LANGUAGES[f],
          value: f,
          prefix: "flag".concat(PREFIX_OVERRIDES[f] || f.toLowerCase()),
          suffix: _react["default"].createElement("span", null, g),
          cost: g
        };
      });
      return f;
    };
  };
}